var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-page-new" }, [
    _c("div", { staticClass: "bgimg-warp" }, [
      _c("div", { staticClass: "title-wrap" }, [
        _c("span", { staticClass: "main" }, [
          _c("img", {
            attrs: { src: require("@/assets/image/logo.jpg"), alt: "" }
          }),
          _c("span", [_vm._v(_vm._s(_vm.$t("page.login.bigTitle")))])
        ]),
        _c("span", { staticClass: "sub" }, [
          _vm._v(_vm._s(_vm.$t("page.login.subTitle")))
        ])
      ])
    ]),
    _c(
      "div",
      { staticClass: "login-bar" },
      [
        _c(
          "div",
          { staticClass: "tool-bar" },
          [
            _c(
              "div",
              { staticClass: "local" },
              [
                _c(
                  "el-dropdown",
                  { on: { command: _vm.onChangeLocale } },
                  [
                    _c("span", { staticClass: "el-dropdown-link" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            this.$i18n.locale === "en" ? "language" : "语言"
                          ) +
                          " "
                      ),
                      _c("i", {
                        staticClass: "el-icon-arrow-down el-icon--right"
                      })
                    ]),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "zh-chs" } },
                          [_vm._v("中文(简体)")]
                        ),
                        _c("el-dropdown-item", { attrs: { command: "en" } }, [
                          _vm._v("English")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("setting-host")
          ],
          1
        ),
        _c("LoginPane"),
        _c("div", { staticClass: "bottom-bar" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("page.login.co-ltd")))]),
          _c("span", { staticStyle: { "margin-top": "5px" } }, [
            _vm._v("v " + _vm._s(_vm.$packageInfo.version))
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }